<template>
  <div
    v-background-color="colorBackground"
    :class="{
      [$style['container']]: true,
      [$style['with-loader']]: showLoader,
    }"
  >
    <v-loader v-if="showLoader" fullScreen :isBlack="!lightLoadingColor" />
    <div v-else>
      <div v-if="mobile">
        <slot />
      </div>
      <div v-if="!mobile" :class="$style['mobile']">
        <div
          :class="{
            [$style['flex']]: true,
            [$style['center']]: true,
          }"
          v-background-color="colorBackground"
        >
          <h1 v-font-style="fontDetailBody" v-color="colorFontBody"
            >Sorry, this is for mobile devices only!</h1
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VLoader from '@components/v-loader.vue'

export default {
  components: {
    VLoader,
  },
  data: () => ({
    mobile: true,
    windowWidth: 0,
  }),
  computed: {
    ...mapGetters('contentful', [
      'colorBackground',
      'colorFontBody',
      'fontDetailBody',
      'contentfulLoadingStatus',
      'lightLoadingColor',
    ]),
    ...mapGetters('ui', ['pageLoadingStatus']),
    showLoader() {
      return (
        this.contentfulLoadingStatus === 'loading' ||
        this.pageLoadingStatus === 'loading'
      )
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  methods: {
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth
      this.mobile = this.desktop ? true : this.windowWidth < 768
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.container {
  // min-width: $size-content-width-min;
  // max-width: $size-content-width-max;
  margin: 0 auto;

  &.with-loader {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  main {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}

.flex {
  background-color: white;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 60px);
}

.center {
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
